import DatePreview from '@/components/DatePreview';
import defaultsDeep from 'lodash/defaultsDeep';
import trimStart from 'lodash/trimStart';
import DatePickerCmp from '@/utils/datePickerFiel';

const defaultFieldConfig = {
  normalize: value => {
    switch (typeof value) {
      case 'string':
        return trimStart(value);
      default:
        return value;
    }
  }
};

const mapFields = (t, fields) => fields.map(
  (field) => {
    const fieldItem = {
      label: field.label && t(field.label),
      tooltip: (field.tooltip && typeof field.tooltip === 'string') ? t(field.tooltip) : field.tooltip,
      extra: (field.extra && typeof field.extra === 'string') ? t(field.extra) : field.extra,
      help: (field.help && typeof field.help === 'string') ? t(field.help) : field.help,
      placeholder: field.placeholder && t(field.placeholder),
      colSpan: field.colSpan || 2,
    };

    if (field?.type === 'date') {
      fieldItem.widget = DatePickerCmp;
      fieldItem.viewWidget = DatePreview;
    }

    return defaultsDeep(fieldItem, field, defaultFieldConfig);
  }
);

export default (t, fields) => {
  if (fields)
    return mapFields(t, fields);
  return fields => mapFields(t, fields);
};
